import { BooleanString } from 'types/utility';

export default function isTrue(val?: BooleanString | boolean) {
  if (!val) {
    return false;
  }

  if (typeof val === 'string') {
    return val.toLowerCase() === 'true';
  }

  return val;
}
